export const environment = {
    production: true,
    iframeSrc: '/oldui/rdx',
    apiUrl: '/rest',
    isSwitch: true,
    baseUrl: '/site/rdx'
};
